import { useState, useEffect } from "react";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";

import useSVG from "../../../hooks/useSVG";
import ResetProgram from "../../home/Components/ResetProgram";
import ProgressBar from "../../../common/ProgressBar";
import { Check } from "../../../common/CustomIcons";

import { programLevels } from "../../../constants";
import { getVimeoVideoDetails } from "../../../utils/vimeo-utils";
import { GetWholeWorkoutByProgram } from "../../../redux/v2/workout/actions";
import { SetModalProperties, ShowModal } from "../../../redux/v2/utils/actions";

function ProgramCard(props) {
    const location = useLocation();

    const { allWorkoutHistory, user, selectedPrograms } = props.User;
    const { program, onClick, grid = 6, key, displayType = null } = props;
    const [videoDetails, setVideoDetails] = useState(null);
    const { UseProgramSVG } = useSVG();

    useEffect(async () => {
        const vimeoVideoDetails = await getVimeoVideoDetails(program?.video);
        setVideoDetails(vimeoVideoDetails);
    }, [program?.video]);

    useEffect(() => {
        if (program?.id && program?.added) {
            props.GetWholeWorkoutByProgram(program?.id, program?.level);
        }
    }, [program?.id]);

    const level = program?.level ? programLevels[program?.level] : "";

    const gradient = program?.gradient?.split("-");
    const svgKey = `${programLevels[program?.level]?.toLowerCase()}${program?.svg}`;
    const svg = UseProgramSVG(svgKey);

    let perc = 0,
        value,
        max;
    let hist = selectedPrograms?.filter((sp) => sp.program_id == program?.id && sp.level == program?.level);
    let done = [];
    let ongoing = 0;
    if (program?.added) {

        for (let x = 0; x < allWorkoutHistory.length; x++) {
            if (program?.id == allWorkoutHistory[x].program && program?.level == allWorkoutHistory[x].level && new Date(allWorkoutHistory[x].created_at) >= new Date(hist[0]?.created_at)) {
                if (allWorkoutHistory[x].percentage < 80) {
                    ongoing++;
                } else {
                    done.push(allWorkoutHistory[x]?.workout_id);
                }
            }
        }
        done = Array.from(new Set(done));
        max = program?.count;
        value = done.length || 0;
        perc = Math.round((value / max) * 100) || 0;
        perc = isNaN(perc) || !isFinite(perc) ? "0" : perc;
    }

    const isInResurvey = location.pathname.includes("/user-survey");
    const isInOnboarding = location.pathname.includes("/user-onboarding");
    const isInProgramIntroduction = location.pathname.includes("/program-introduction");
    const isInPatientInvite = location.pathname.includes("/patient-invite");
    const isInPrograms = location.pathname.includes("/programs");

    const isProgramAdded = (program?.added && ((isInProgramIntroduction || isInOnboarding || isInPatientInvite || isInPrograms) || ((isInResurvey && program?.choosen) && displayType == 3 || (isInResurvey && displayType == 4))));

    return (
        <div
            className={`col-md-${grid} flex-c ${((isInResurvey || isInOnboarding || isInPrograms) && !isProgramAdded) ? "not-added-program" : ""}`}
            key={key}
            onClick={() => {
                if (program?.added && isInPrograms) {
                    props.SetModalProperties({
                        // showCloseButton: false,
                        isShow: true,
                        title: "",
                        body: (
                            <ResetProgram
                                setShowModal={() => {
                                    props.ShowModal(false);
                                }}
                                selected={program}
                                perc={perc}
                            />
                        ),
                        actions: [],
                    });
                } else {
                    onClick();
                }
            }}
        >
            {program?.added && (
                <>
                    <div className="onb-v2-card clickable added-card" style={{ backgroundColor: "#eaeaea" }}>
                        <div className="onb-v2-card-icon">
                            <div className="onb-v2-card-icon-wrapper" style={{ backgroundImage: `linear-gradient(to right, ${gradient?.[0]}, ${gradient?.[1]})` }}>
                                {svg}
                            </div>
                        </div>
                        {(isInProgramIntroduction || isInOnboarding || isInResurvey || isInPatientInvite) ? (
                            <>
                                <div className="onb-v2-card-details">
                                    <h5>{`${program?.title}${level ? " - " + level?.toLowerCase() : ""}`}</h5>
                                    <h6>{program?.type}</h6>
                                    <h6>{(done?.length || 0)} / {(program?.count)} Completed</h6>
                                </div>
                            </>
                        ) : (
                            <>
                                <div className="onb-v2-card-details">
                                    <h5>{`${program?.title}${level ? " - " + level?.toLowerCase() : ""}`}</h5>
                                    <h6>{`${value} out of ${max} completed`}</h6>
                                    <ProgressBar min={0} max={max} value={value} gradient={program?.gradient ? program?.gradient?.split("-") : null} showLabel={false} />
                                </div>
                            </>
                        )}

                        {(isInProgramIntroduction || isInOnboarding || isInPatientInvite) && (
                            <div id="onb-v2-card-active-tag">
                                <Check style={{ fill: gradient?.[0] }} />
                                <h6>Added</h6>
                            </div>
                        )}

                        {((isInResurvey && program?.choosen) && displayType == 3 || (isInResurvey && displayType == 4)) && (
                            <div id="onb-v2-card-active-tag">
                                <h6>Remove</h6>
                            </div>
                        )}
                        {((isInResurvey && !program?.choosen) && displayType == 3) && (
                            <div id="onb-v2-card-active-tag">
                                <h6>Add</h6>
                            </div>
                        )}

                    </div>
                </>
            )}

            {!program?.added && (
                <>
                    <div className="onb-v2-card clickable" style={{ backgroundImage: `linear-gradient(to right, ${gradient?.[0]}, ${gradient?.[1]})` }}>
                        <div className="onb-v2-card-icon">{svg}</div>
                        <div className="onb-v2-card-details">
                            <h5>{`${program?.title}${level ? " - " + level?.toLowerCase() : ""}`}</h5>
                            <h6>{program?.type}</h6>
                            <h6>{program?.timeline}</h6>
                            <h6>Ave. Length: {program?.time} mins</h6>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
}

const mapStateToProps = (state) => ({
    User: state.User,
    Workout: state.Workout,
    Program: state.Program,
});

export default connect(mapStateToProps, {
    SetModalProperties,
    ShowModal,
    GetWholeWorkoutByProgram,
})(ProgramCard);
